import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom';
import { sendLoginSSO } from '../../actions/userActions'
import { bindActionCreators } from 'redux'
import { withRouter } from '../../actions/withRouterHook';

function CallbackSSOContainer(props) {
    let navigate = useNavigate();
    let location = useLocation();

    // trigger on component mount
    // TODO: Look up to make sure [location.search] is the correct thing to use since we are using react hooks now
    useEffect(() => {
        if (props.loggedIn === true || props.ssoFail) {
            navigate("/");
        } else if (props.ssoFlag) {
            let urlParams = new URLSearchParams(location.search);
            let code = urlParams.get("code");
            props.sendLoginSSO(code);
        }
    });

    if (!props.loggedIn) {
        return <div className="blank" style={{backgroundColor: "white"}}></div>;
    } else {
        navigate("/");
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.users.loggedIn,
        ssoFail: state.users.ssoFail,
        ssoFlag: state.users.ssoFlag,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ sendLoginSSO }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CallbackSSOContainer))